namespace GeniuzPOS.AdvPromo {
    export class Report_Adv04Columns {
        static columnsKey = 'AdvPromo.Report_Adv04';
    }
}
